export interface IColorOptionProps {
  color: string;
  onChange: (color: string) => void;
}

export interface IColorOptionState {
  isVisible: boolean;
}

export function ColorOption({ color, onChange }: IColorOptionProps) {
  return (
    <div>
      <input
        type="color"
        id="color"
        className="position-absolute opacity-0 btn btn-icon"
        value={color}
        onChange={event => onChange(event.currentTarget.value)}
        list="colors"
      />
      <label htmlFor="color" className="btn btn-primary btn-icon cursor-pointer">
        <i
          className="icon icon-md"
          style={{
            color,
          }}
        >
          border_color
        </i>
      </label>
      <datalist id="colors">
        <option value="#d9e3f0">White</option>
        <option value="#f47373">Red</option>
        <option value="#697689">Gray</option>
        <option value="#37d67a">Green</option>
        <option value="#2ccce4">Blue</option>
        <option value="#555555">Black</option>
        <option value="#dce775">Yellow</option>
        <option value="#ff8a65">Orange</option>
        <option value="#ba68c8">Purple</option>
      </datalist>
    </div>
  );
}
